export const environment = {
  production: true,
  //apiUrl: 'http://localhost/eyesNroad/eyesNroad-API/public',
  apiUrl: 'https://dev.api.eyesnroad.com',
  //appUrl: 'http://localhost:4200',
  appUrl: 'https://dev.app.eyesnroad.com',
  ssrPort: 4000,
  google_cliend_id:
    '333176237235-sp8e297lmh5efbuin0dgqvshd6gl25ec.apps.googleusercontent.com',
};
